module.exports = __webpack_public_path__ + "static/media/image@2x.b79e7f6d.jpg";